import axios from 'axios'

let api = null
let apiAWS = null
let apiUpload = null

export function createApi() {
  api = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_API_BACKEND}` || 'http://localhost:3030',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  return api
}

export function useApi() {
  if (!api) {
    createApi()
  }
  return api
}

export function createApiUoload() {
  apiUpload = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_API_BACKEND}` || 'http://localhost:3030',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return apiUpload
}

export function useApiUpload() {
  if (!apiUpload) {
    createApiUoload()
  }
  return apiUpload
}

export function createApiAWS() {
  apiAWS = axios.create({
    baseURL: process.env.VUE_APP_HOST_API_AWS_S3,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  return apiAWS
}

export function useApiAWS() {
  if (!apiAWS) {
    createApiAWS()
  }
  return apiAWS
}
